export const CONTAINERIZATION_SUCCESS = 'Successfully Containerized!';
export const MOVE_SUCCESS = 'Successfully Moved!';
export const CONTAINERS = 'Containers';
export const CLOSE_CONTAINER_SUCCESS = 'Container successfully closed!'
export const RECEIVE_CONTAINER_SUCCESS = 'Container successfully received!'
export const PRINT_SUCCESS = 'Label sent to Printer: '
export const PROCESS_CONTAINER_SUCCESS = 'Container sent for processing successfully!';
export const SET_ROUTING_DESTINATION_SUCCESS = 'Routing destination assigned successfully!';
export const CLEAN_A_DIRTY_CONTAINER_SUCCESS = 'Container successfully cleaned!';
